import React from 'react';

export type IconV1Props = {
    svgSpriteId: string,
    width?: string | number,
    height?: string | number,
    classes?: string[],
}

const IconV1 = (props: IconV1Props) => {

    let classes = ['icon-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <svg className={classes.join(' ')} width={props.width} height={props.height}>
            <use xlinkHref={`/build/sprite.svg#${props.svgSpriteId}`}></use>
        </svg>
    );

}

export default IconV1;